export default {
  methods: {
    validateCharacter(val) {
      let charset = "[a-z\u0400-\u04FF-]";
      let reg = new RegExp(`^${charset}`);
      return val.target.value.replace(reg, "");
    }
  }
};
